import React from 'react';
import { ProgressBar } from 'react-bootstrap';

function Progress({ heading, label, parcent }) {
  return (
    <div className="single-progress d-flex justify-content-between align-items-center">
      <div className="progress-bar-wrapper">
        <h3 className="progress-heading">{heading}</h3>
        <div className="skillbar clearfix" data-percent="75%">
          <div className="skill-bar-percent">{label}</div>
          <ProgressBar className="bar" now={parcent} />
        </div>
      </div>
    </div>
  );
}

export default Progress;
